import { CURRENT_ENV } from '@sketch/env-config';

// Proper domains for environments
const domain = {
    local: 'https://dev.',
    test: 'https://test.',
    dev: 'https://dev.',
    staging: 'https://staging.',
    production: 'https://www.',
};
/**
 * Will output the correct Sketch website depending
 * on the environment
 *
 * @example
 * <Link href={`${SKETCH_WEBSITE}/home`}
 */
const SKETCH_WEBSITE = `${domain[CURRENT_ENV]}sketch.com`;

export { SKETCH_WEBSITE };
